import { PageViewData } from '../GTM'

export const storeUserState = (
    data: Record<string, unknown>,
    addStoredData: (data: PageViewData) => void
): void => {
    const { id, isSignedIn, email } = data
    const userLogState: Record<string, unknown> = {
        customerLoggedIn: isSignedIn ? 'Yes' : 'No',
        customerEmail: email
    }
    if (!!id && !!isSignedIn) {
        userLogState['customerId'] = id
    }

    addStoredData({ userLogState: userLogState })
}
